import { Badge } from "@/components/ui/badge";

interface CartFooterProps {
  itemCount: number;
  totalPrice: number;
  // onCheckout: () => void;
}

/**
 * CartFooter Component
 * Displays total price, item count, and checkout button
 * Only renders when there are items in cart
 */
export function CartFooter({
  itemCount,
  totalPrice,
  // onCheckout,
}: CartFooterProps) {
  if (itemCount === 0) return null;

  return (
    <div className="flex flex-col gap-1 rounded-[8px] bg-neutral-100 px-5 py-3">
      <div className="flex flex-row justify-between">
        <div className="flex flex-row items-center gap-1.5">
          <h1 className="text-lg font-extrabold -tracking-wide text-neutral-900">
            Total
          </h1>
          <Badge variant="outline" className="border-neutral-200 font-medium">
            {itemCount}
          </Badge>
        </div>
        <h1 className="text-brand-500 text-xl leading-none font-extrabold -tracking-wide">
          ${totalPrice.toLocaleString()}
        </h1>
      </div>
      {/* <Button className="h-[48px]" onClick={onCheckout}>
        Checkout
      </Button> */}
    </div>
  );
}
